import { createContext } from 'react'

export type ToastSeverity = 'success' | 'error' | 'info' | 'warning'

export interface ToastContextValue {
  show: (message: string, severity?: ToastSeverity) => void
}

export const ToastContext = createContext<ToastContextValue | null>(null)
